$(document).ready(function () {
$('.hero-banner').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.hero-banner-nav',
      autoplay: false,
      autoplaySpeed: 11000,
      dots: false,
  });
$('.hero-banner-nav').not('.slick-initialized').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.hero-banner',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: false,
    vertical:true
});
$('.slick-sec4').not('.slick-initialized').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        autoplay: false,
        autoplaySpeed: 11000,
        dots: false,
        responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
    });

    $('.slick-sec6').not('.slick-initialized').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        autoplay: false,
        autoplaySpeed: 11000,
        dots: false,
        responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
    });
$('.acc .acc_bt').click(function(){
      $('.acc_bt').removeClass('active');
      
      $('.acc .acc_cnt').stop(true).slideUp(500);
      if($(this).hasClass('accordion-open')){
        $('.acc .acc_bt').removeClass('accordion-open');
        $(this).removeClass('active');
        $(this).next('.acc_cnt').stop(true).slideUp(500);
      } else {
        $('.acc .acc_bt').removeClass('accordion-open');
        $(this).addClass('accordion-open');
        $(this).addClass('active');
        $(this).next('.acc_cnt').stop(true).slideDown(500);
      }
});


var urli = new URL(window.location.href);
var params = new URLSearchParams(urli.search);
var arguments = params.get('variant');
//alert(arguments);

  if(arguments == '44335002059042'){
     $('.hero-banner').slick('slickGoTo', 2);
 
  }
  if(arguments == '39448229183566'){
    
      $('.hero-banner').slick('slickGoTo', 1);
   
  }
    if(arguments == '44335002124578'){
     $('.hero-banner').slick('slickGoTo', 0);
  }



  $('.slideforlike').not('.slick-initialized').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      fade: false,
      
      autoplay: false,
      autoplaySpeed: 6000,
    nextArrow: '<button class="slick-button prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  prevArrow: '<button class="slick-button prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      dots: true,

   responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                 slidesToScroll: 1
              }
            }
          ]
  
  });
  
});